import { jsx } from "react/jsx-runtime";
import { Radio } from "antd";
import classnames from "classnames";
import card_group from "./components/card-group/index.js";
import { rootClass } from "./constant.js";
function Group(props) {
    const { layout = 'horizontal', optionType, options, ...rest } = props;
    if ('card' === optionType) return /*#__PURE__*/ jsx(card_group, {
        ...props
    });
    return /*#__PURE__*/ jsx(Radio.Group, {
        ...rest,
        optionType: optionType,
        options: options?.map((item)=>{
            if ('string' == typeof item || 'number' == typeof item) return {
                label: item,
                value: item,
                className: rootClass
            };
            return {
                ...item,
                className: classnames(item.className, rootClass)
            };
        }),
        className: classnames(rest.className, `${rootClass}__${layout}`)
    });
}
export { Group as default };
